<template>
    <v-dialog v-model="assetUrl" v-on:input="onBackgroundClicked" content-class="image-dialog">
      <img v-if="isImage" class="lightbox-image" :src="assetUrl" align-center/>
      <embed v-if="isPdf" class="lightbox-pdf" :src="assetUrl" align-center :height="windowHeight - 200"/>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/mutationTypes';

export default {
  name: 'Lightbox',
  data() {
    return {
      windowHeight: document.documentElement.clientHeight,
    }
  },
  computed:{
    ...mapGetters('lightbox', ['asset', 'assetType', 'assetUrl']),
    isPdf() {
      return this.assetType === 'application/pdf';
    },
    isImage() {
      return this.assetType && this.assetType.toLocaleLowerCase().startsWith('image');
    },
  } ,
  methods: {
    onBackgroundClicked(open){
      if (open === false){
        this.$store.dispatch('lightbox/dismiss');
      }
    }
  },
  watch:{
    asset({url,type}) {
      if(!url){
        return;
      }

      const isOnMobile = this.$vuetify.breakpoint.smAndDown
      const isSupportedType = this.isImage || this.isPdf

      if(isOnMobile || !isSupportedType){
        this.$store.dispatch('lightbox/dismiss');
        
        window.open(url, '_self');
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.resizeFunction = window.addEventListener('resize', () => {
        this.windowHeight = document.documentElement.clientHeight
      });
    })
  },
};
</script>

<style>
.lightbox-image {
  max-width: 100%;
  border-radius: 2px;
}
.lightbox-pdf {
  min-width: 720px;
}
.image-dialog {
  width: auto;
  box-shadow: none;
  background-color: transparent;
  margin:64px;
}
</style>



// WEBPACK FOOTER //
// src/components/Lightbox.vue